import { render, staticRenderFns } from "./dg-page.vue?vue&type=template&id=6f454321&scoped=true"
import script from "./dg-page.vue?vue&type=script&lang=js"
export * from "./dg-page.vue?vue&type=script&lang=js"
import style0 from "./dg-page.vue?vue&type=style&index=0&id=6f454321&prod&lang=less&scoped=true"
import style1 from "./dg-page.vue?vue&type=style&index=1&id=6f454321&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f454321",
  null
  
)

export default component.exports